import * as FileSystem from 'expo-file-system';
// import { manipulateAsync } from 'expo-image-manipulator';
import * as ImagePicker from 'expo-image-picker';
import mime from 'mime';
import i18n from '../../assets/i18n';
import avatar1 from '../../assets/images/avatar_mit_background.png';
import { Alert, Image, Platform } from 'react-native';

const MAX_MB = 30;
const factor = Platform.OS === 'web' ? 1000 : Platform.OS === 'ios' ? 1112 : 1024;
const MAX_MEDIA = MAX_MB * factor * factor;

export const requestPermissions = async () => {
    if (Platform.OS !== 'web') {
        const { status } = await ImagePicker.requestMediaLibraryPermissionsAsync();
        if (status !== 'granted') {
            alert(i18n.t('mediaSelector.photosPermission'));
        }
        const statusCam = await ImagePicker.requestCameraPermissionsAsync();
        if (!statusCam.granted) {
            alert(i18n.t('mediaSelector.cameraPermission'));
        }
    }
};

const sizeAlert = (size) => {
    console.log('XXX', size, factor);
    if (Platform.OS === 'web') {
        alert(i18n.t('global.warning') + '\n' + i18n.t('global.mediaSize', { size: Math.ceil((size * 100) / factor / factor) / 100, max: MAX_MB }));
    } else {
        Alert.alert(i18n.t('global.warning'), i18n.t('global.mediaSize', { size: Math.ceil((size * 100) / factor / factor) / 100, max: MAX_MB }), [{ text: 'OK', onPress: () => {} }]);
    }
};

export const takePhoto = async (imageCrop, callback) => {
    const crop = imageCrop ? { aspect: [1, 1] } : {};
    let result = await ImagePicker.launchCameraAsync({
        mediaTypes: ['images', 'livePhotos', 'videos'],
        allowsEditing: true,
        quality: 0.5,
        videoMaxDuration: 30,
        ...crop
    });

    if (!result.canceled) {
        if (Platform.OS !== 'web') {
            const fileInfo = await FileSystem.getInfoAsync(result.assets[0].uri);
            console.log('PHOTO', fileInfo, result.assets);
            if (fileInfo.size > MAX_MEDIA) {
                sizeAlert(fileInfo.size);
                callback(null);
            } else {
                callback(result.assets[0]);
            }
        } else {
            callback(result.assets[0]);
        }
    }
};

export const takeVideo = async (imageCrop, callback) => {
    const crop = imageCrop ? { aspect: [1, 1] } : {};
    let result = await ImagePicker.launchCameraAsync({
        mediaTypes: 'videos',
        allowsEditing: true,
        quality: 0.2,
        videoMaxDuration: 30,
        VideoQuality: ImagePicker.UIImagePickerControllerQualityType.Low,
        ...crop
    });

    if (!result.canceled) {
        if (Platform.OS !== 'web') {
            const fileInfo = await FileSystem.getInfoAsync(result.assets[0].uri);
            console.log('VIDEO', fileInfo, result.assets);
            if (fileInfo.size > MAX_MEDIA) {
                sizeAlert(fileInfo.size);
                callback(null);
            } else {
                callback(result.assets[0]);
            }
        } else {
            callback(result.assets[0]);
        }
    }
};

export const pickImage = async (title, imageCrop, callback) => {
    const crop = imageCrop ? { aspect: [1, 1] } : {};
    try {
        let result = await ImagePicker.launchImageLibraryAsync({
            mediaTypes: ImagePicker.MediaTypeOptions.All,
            allowsEditing: true,
            quality: 0.5,
            exif: false,
            ...crop
        });

        if (!result.canceled) {
            const image = result.assets[0];
            if (Platform.OS === 'web') {
                const size = (image.uri.length / 4) * 3;
                if (size > MAX_MEDIA) {
                    sizeAlert(size);
                    callback(null);
                    return;
                }
                callback(image);
            } else {
                const fileInfo = await FileSystem.getInfoAsync(image.uri);
                console.log('MEDIA', fileInfo, result.assets);
                if (fileInfo.size > MAX_MEDIA) {
                    sizeAlert(fileInfo.size);
                    callback(null);
                } else {
                    callback(image);
                }
            }
        }
    } catch (error) {
        console.log('PICKER', '' + error);
        Alert.alert(i18n.t('global.error'), i18n.t('global.mediaPickError'), [{ text: 'OK', onPress: () => {} }]);
    }
};

const renameImagesPNG = async (dir) => {
    if (Platform.OS === 'ios') {
        const dirInfo = await FileSystem.getInfoAsync(dir);
        if (dirInfo.exists) {
            const files = await FileSystem.readDirectoryAsync(dir);
            let pngCnt = 0;
            files
                .filter((file) => getExtension(file) == '')
                .forEach((file) => {
                    try {
                        FileSystem.moveAsync({ from: dir + file, to: dir + file + '.png' });
                        pngCnt++;
                    } catch (error) {
                        FileSystem.getInfoAsync(dir + file).then((fileInfo) => {
                            console.log('EXIST?', file, fileInfo);
                        });
                    }
                });
            if (pngCnt > 0) {
                Alert.alert(i18n.t('global.info'), pngCnt + ' media files renamed to .png', [{ text: 'OK', onPress: () => {} }]);
            }
            // console.log(dir, pngCnt + ' media files renamed to .png')
        }
    }
};

export const inaDir = Platform.OS !== 'web' ? FileSystem.documentDirectory + 'ina_coach/' : new URL(window.location).origin; // 'http://localhost:8081';
console.log('INADIR', inaDir);
renameImagesPNG(inaDir);
const LOADED = {};

export const imageSrc = (image, noCache) => {
    let src;
    if (Platform.OS === 'web') {
        if (typeof image == 'number' || typeof image == 'object') {
            src = image;
        } else {
            src = image == null ? { uri: null } : { uri: image.startsWith('data:') || image.startsWith('file:///') ? image : inaDir + '/api/contact/media/' + image.replace(/\..*/, '') + (noCache ? '?r=' + noCache : '') };
        }
    } else {
        // TODO: Test only! Caching completely disabled
        // noCache = noCache == undefined ? Date.now() : noCache
        src = image == null ? 0 : typeof image == 'number' ? (image == 2 ? avatar1 : image) : { uri: image.startsWith('file:///') ? image : inaDir + image };
        if (noCache && src?.uri) {
            src.uri += '?r=' + noCache;
            src.cache = 'reload';
        }
    }
    // if (LOADED[image]) {
    //     LOADED[image]++
    // } else {
    //     LOADED[image] = 1
    // }
    // console.log('IMGSRC', src, LOADED[image])
    return src;
};

export const isMedia = (uri) => {
    const mimeType = getMineType(uri);
    return mimeType?.startsWith('video/') || mimeType?.startsWith('audio/');
};

export const isVideo = (uri) => {
    return getMineType(uri)?.startsWith('video/');
};

export const isAudio = (uri) => {
    return getMineType(uri)?.startsWith('audio/');
};

export const getExtension = (uri) => {
    const file = uri.split(/[#?]/)[0].split(/[/]/).pop();
    return file.indexOf('.') == -1 ? '' : file.split('.').pop().trim();
};

export const getMineType = (uri) => {
    let mimeType = null;
    if (typeof uri == 'number') {
        // internal asset
        try {
            const img = Image.resolveAssetSource(uri).uri;
            const match = img.match(/[^/\\&?]+\.(\w+)(?=([?&]|$))/);
            mimeType = mime.getType(match[0]);
        } catch (e) {
            // ignore
        }
    } else {
        mimeType = mime.getType(uri);
    }
    return mimeType;
};

// create inaDir directory if it does not exist
export const ensureDirExists = async () => {
    if (Platform.OS !== 'web') {
        const dirInfo = await FileSystem.getInfoAsync(inaDir);
        if (!dirInfo.exists) {
            console.log("InA Coach directory doesn't exist, creating...");
            await FileSystem.makeDirectoryAsync(inaDir, { intermediates: true });
        }
    }
};

export const isUUID = (id) => {
    return /^[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(id);
};

const storeImageAsync = async (uri, filename) => {
    let fileInfo;
    try {
        fileInfo = await FileSystem.getInfoAsync(uri);
        const base64 = await FileSystem.readAsStringAsync(uri, { encoding: 'base64' });
        await FileSystem.writeAsStringAsync(inaDir + filename, base64, { encoding: FileSystem.EncodingType.Base64 });
        return true;
    } catch (error) {
        console.log('IMGCOPY', '' + error);
        Alert.alert(i18n.t('global.error'), i18n.t('global.mediaStoreError', { size: fileInfo ? fileInfo.size : '??' }), [{ text: 'OK', onPress: () => {} }]);
        return false;
    }
};

export const storeImagesAsync = async (uris) => {
    if (Platform.OS == 'web') {
        return uris;
    } else {
        if (FileSystem.documentDirectory) {
            let failed = [];
            for (const uri of uris.filter((uri) => typeof uri != 'number' && uri.startsWith(FileSystem.cacheDirectory))) {
                // copy localFiles to InA directory
                console.log('READ', uri);
                if (!(await storeImageAsync(uri, uri.substr(uri.lastIndexOf('/') + 1)))) {
                    failed.push(uri);
                }
            }
            return uris.filter((uri) => !failed.includes(uri)).map((uri) => (typeof uri != 'number' && uri.startsWith(FileSystem.cacheDirectory) ? inaDir + uri.substr(uri.lastIndexOf('/') + 1) : uri));
        }
    }
    return uris;
};

export const cleanImages = async () => {
    if (Platform.OS !== 'web') {
        await cleanImagesDir(inaDir);
    }
};

export const cleanImagesCache = () => {
    cleanImagesDir(FileSystem.cacheDirectory + 'ImagePicker/');
};

const cleanImagesDir = async (dir) => {
    if (Platform.OS !== 'web') {
        const dirInfo = await FileSystem.getInfoAsync(dir);
        if (dirInfo.exists) {
            const files = await FileSystem.readDirectoryAsync(dir);
            files.forEach((file) => FileSystem.deleteAsync(dir + file));
            console.log(dir, files.length + ' media files deleted');
        }
    }
};

export const deleteImagesAsync = async (uris) => {
    if (Platform.OS !== 'web') {
        uris.forEach((uri) => {
            let src = imageSrc(uri);
            if (src.uri) {
                FileSystem.getInfoAsync(src.uri).then((fileInfo) => {
                    if (fileInfo.exists) {
                        console.log('Delete: ', uri);
                        FileSystem.deleteAsync(src.uri);
                    }
                });
            }
        });
    }
};
